import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import { X } from 'lucide-react';
import Icon from '../primitives/Icon.jsx';

/**
 * A focused task over the page. The owner controls `open`; `footer` holds the actions,
 * with the main action last. Escape and the close button call onOpenChange(false).
 */
const Dialog = ({ open, onOpenChange, title, description, footer, children }) => {
  return (
    <BaseDialog.Root open={open} onOpenChange={onOpenChange}>
      <BaseDialog.Portal>
        <BaseDialog.Backdrop className="comp-dialog__backdrop" />
        <BaseDialog.Popup className="comp-dialog">
          <header className="comp-dialog__header">
            <BaseDialog.Title className="comp-dialog__title">{title}</BaseDialog.Title>
            <BaseDialog.Close className="comp-dialog__close" aria-label="Close">
              <Icon icon={X} />
            </BaseDialog.Close>
          </header>
          {description && <BaseDialog.Description className="comp-dialog__description">{description}</BaseDialog.Description>}
          {children && <div className="comp-dialog__body">{children}</div>}
          {footer && <footer className="comp-dialog__footer">{footer}</footer>}
        </BaseDialog.Popup>
      </BaseDialog.Portal>
    </BaseDialog.Root>
  );
};

export default Dialog;
